import React from "react";

// components

export default function TableSocialTraffic() {
  return (
    <>
      <table className="items-center w-full bg-transparent border-collapse">
        <thead className="thead-light">
          <tr>
            <th className="table-header">Referral</th>
            <th className="table-header">Visitors</th>
            <th className="table-header min-w-140-px"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th className="table-data">Facebook</th>
            <td className="table-data">1,480</td>
            <td className="table-data">
              <div className="flex items-center">
                <span className="mr-2">60%</span>
                <div className="relative w-full">
                  <div className="overflow-hidden h-2 text-xs flex rounded bg-red-200">
                    <div
                      style={{ width: "60%" }}
                      className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-red-500"
                    ></div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th className="table-data">Facebook</th>
            <td className="table-data">5,480</td>
            <td className="table-data">
              <div className="flex items-center">
                <span className="mr-2">70%</span>
                <div className="relative w-full">
                  <div className="overflow-hidden h-2 text-xs flex rounded bg-emerald-200">
                    <div
                      style={{ width: "70%" }}
                      className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-emerald-500"
                    ></div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th className="table-data">Google</th>
            <td className="table-data">4,807</td>
            <td className="table-data">
              <div className="flex items-center">
                <span className="mr-2">80%</span>
                <div className="relative w-full">
                  <div className="overflow-hidden h-2 text-xs flex rounded bg-purple-200">
                    <div
                      style={{ width: "80%" }}
                      className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-purple-500"
                    ></div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th className="table-data">Instagram</th>
            <td className="table-data">3,678</td>
            <td className="table-data">
              <div className="flex items-center">
                <span className="mr-2">75%</span>
                <div className="relative w-full">
                  <div className="overflow-hidden h-2 text-xs flex rounded bg-lightBlue-200">
                    <div
                      style={{ width: "75%" }}
                      className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-lightBlue-500"
                    ></div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th className="table-data">twitter</th>
            <td className="table-data">2,645</td>
            <td className="table-data">
              <div className="flex items-center">
                <span className="mr-2">30%</span>
                <div className="relative w-full">
                  <div className="overflow-hidden h-2 text-xs flex rounded bg-orange-200">
                    <div
                      style={{ width: "30%" }}
                      className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-emerald-500"
                    ></div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
}
